var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoEmployeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.8335C11.3333 12.7289 9.84095 11.8335 8 11.8335C6.15905 11.8335 4.66667 12.7289 4.66667 13.8335M14 11.8337C14 11.0136 13.1773 10.3088 12 10.0002M2 11.8337C2 11.0136 2.82273 10.3088 4 10.0002M12 7.32423C12.4092 6.95802 12.6667 6.42583 12.6667 5.8335C12.6667 4.72893 11.7712 3.8335 10.6667 3.8335C10.1544 3.8335 9.68717 4.02607 9.33333 4.34276M4 7.32423C3.59083 6.95802 3.33333 6.42583 3.33333 5.8335C3.33333 4.72893 4.22876 3.8335 5.33333 3.8335C5.84557 3.8335 6.31283 4.02607 6.66667 4.34276M8 9.8335C6.89543 9.8335 6 8.93807 6 7.8335C6 6.72893 6.89543 5.8335 8 5.8335C9.10457 5.8335 10 6.72893 10 7.8335C10 8.93807 9.10457 9.8335 8 9.8335Z",
    stroke: "#404252",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEmployeeIcon);
export default __webpack_public_path__ + "static/media/NoEmployeeIcon.bf5571381db7afdb65baf280353756a6.svg";
export { ForwardRef as ReactComponent };